import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const stats = [
  {
    icon: (
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
        <polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
    ),
    label: 'تتكون من',
    value: 'من 1 - 3 غرف',
  },
  {
    icon: (
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
        <line x1="1" y1="10" x2="23" y2="10"/>
      </svg>
    ),
    label: 'دفعة أولى',
    value: '20%',
  },
  {
    icon: (
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23"/>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
      </svg>
    ),
    label: 'أسعار تبدأ من',
    value: '1.26 مليون درهم',
  },
  {
    icon: (
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
        <line x1="16" y1="2" x2="16" y2="6"/>
        <line x1="8" y1="2" x2="8" y2="6"/>
        <line x1="3" y1="10" x2="21" y2="10"/>
      </svg>
    ),
    label: 'موعد التسليم',
    value: 'تسليم في 2030',
  },
];

export const EmaarDepartment = () => {
  const sectionRef = useRef(null);
  const headerRef  = useRef(null);
  const cardRefs   = useRef([]);

  // Header animation - نفس طريقة masar
  useEffect(() => {
    const section = sectionRef.current;
    const header  = headerRef.current;
    if (!section || !header) return;

    gsap.set(header, { opacity: 0, y: 35 });

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          gsap.to(header, { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' });
        } else {
          gsap.set(header, { opacity: 0, y: 35 });
        }
      });
    }, { threshold: 0.1 });

    obs.observe(section);
    return () => obs.disconnect();
  }, []);

  // Cards animation - كل كارت بـ delay مختلف
  useEffect(() => {
    const section = sectionRef.current;
    const cards   = cardRefs.current.filter(Boolean);
    if (!section || !cards.length) return;

    gsap.set(cards, { opacity: 0, y: 40 });

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          gsap.to(cards, {
            opacity:  1,
            y:        0,
            duration: 0.7,
            ease:     'power3.out',
            stagger:  0.15, // كل كارت بعد التاني بـ 0.15s
          });
        } else {
          gsap.set(cards, { opacity: 0, y: 40 });
        }
      });
    }, { threshold: 0.1 });

    obs.observe(section);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      style={{
        background:  '#fff',
        padding:     '80px 6vw',
        fontFamily:  "'Cairo', sans-serif",
        direction:   'rtl',
      }}
    >
      {/* Header */}
      <div ref={headerRef} style={{ marginBottom: '56px', opacity: 0 }}>
        <p style={{
          fontSize:      '13px',
          fontWeight:    '600',
          color:         '#c8a04a',
          letterSpacing: '3px',
          textTransform: 'uppercase',
          margin:        '0 0 12px 0',
        }}>
          EMAAR GOLF FIELD
        </p>
        <h2 style={{
          fontSize:   'clamp(28px, 4vw, 48px)',
          fontWeight: '900',
          color:      '#1a1a1a',
          margin:     '0 0 20px 0',
          lineHeight: '1.2',
        }}>
          شقق إعمار
        </h2>
        <div style={{
          width:        '60px',
          height:       '3px',
          background:   'linear-gradient(to left, #c8a04a, #f0d080)',
          borderRadius: '2px',
          marginBottom: '24px',
        }} />
        <p style={{
          fontSize:  'clamp(14px, 1.6vw, 17px)',
          color:     '#555',
          lineHeight: '1.9',
          maxWidth:  '780px',
        }}>
          <strong style={{ color: '#1a1a1a' }}>جولف فيلد</strong> هو مشروع سكني راقٍ من{' '}
          <strong style={{ color: '#1a1a1a' }}>إعمار العقارية</strong> في{' '}
          <strong style={{ color: '#1a1a1a' }}>إعمار الجنوب – دبي</strong>، يضم شققًا من غرفة إلى 3 غرف نوم
          بإطلالات مباشرة على ملعب الجولف. يتميز بتصميم عصري، ومرافق متكاملة، وأسلوب حياة هادئ يجمع
          بين الفخامة والطبيعة، وواحدة من أبرز الوجهات السكنية والاستثمارية في دبي.{' '}
          <span style={{ color: '#c8a04a' }}>✦</span>
        </p>
      </div>

      {/* Stats Grid */}
      <div style={{
        display:             'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap:                 '24px',
      }}>
        {stats.map((stat, i) => (
          <div
            key={i}
            ref={(el) => (cardRefs.current[i] = el)}
            style={{
              border:       '1px solid #e8e0d0',
              borderRadius: '16px',
              padding:      '36px 24px',
              textAlign:    'center',
              background:   '#fdfcf9',
              position:     'relative',
              overflow:     'hidden',
              opacity:      0,
              transition:   'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',
              cursor:       'default',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform   = 'translateY(-6px)';
              e.currentTarget.style.boxShadow   = '0 16px 48px rgba(200,160,74,0.15)';
              e.currentTarget.style.borderColor = '#c8a04a';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform   = 'translateY(0)';
              e.currentTarget.style.boxShadow   = 'none';
              e.currentTarget.style.borderColor = '#e8e0d0';
            }}
          >
            {/* Top accent line */}
            <div style={{
              position:     'absolute',
              top:          0,
              left:         '50%',
              transform:    'translateX(-50%)',
              width:        '40px',
              height:       '3px',
              background:   'linear-gradient(to left, #c8a04a, #f0d080)',
              borderRadius: '0 0 4px 4px',
            }} />

            {/* Icon */}
            <div style={{
              color:          '#c8a04a',
              marginBottom:   '16px',
              display:        'flex',
              justifyContent: 'center',
            }}>
              {stat.icon}
            </div>

            {/* Label */}
            <p style={{
              fontSize:      '13px',
              color:         '#999',
              fontWeight:    '500',
              margin:        '0 0 8px 0',
              letterSpacing: '0.5px',
            }}>
              {stat.label}
            </p>

            {/* Value */}
            <p style={{
              fontSize:   'clamp(18px, 2vw, 22px)',
              fontWeight: '800',
              color:      '#1a1a1a',
              margin:     0,
            }}>
              {stat.value}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};